<template>
  <div class="grid-x grid-margin-x">
    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
        <label>Account Name</label>
        <input
          type="text"
          id="accountName"
          name="accountName"
          placeholder=""
          :value="accountName"
          @input="$emit('update:accountName', $event.target.value)"
          maxlength="35"
          required
        />
      </form>
    </div>
    <div class="cell small-12"></div>
    <div class="cell small-3">
      <form @submit.prevent>
        <label>Account Number</label>
        <input
          type="text"
          id="accountNumber"
          name="accountNumber"
          placeholder=""
          :value="accountNumber"
          @input="$emit('update:accountNumber', $event.target.value)"
          maxlength="8"
          required
        />
      </form>
    </div>
    <div class="cell small-3">
      <form @submit.prevent>
        <label>Sort Code</label>
        <input
          type="text"
          id="sortCode"
          name="sortCode"
          :value="sortCode"
          @input="onSortCodeInput($event)"
          maxlength="8"
          required
        />
      </form>
    </div>
  </div>
</template>

<script setup>
defineProps({
  accountName: String,
  accountNumber: String,
  sortCode: String
})
const emit = defineEmits(['update:accountName', 'update:accountNumber', 'update:sortCode'])


function onSortCodeInput(event) {

  let raw = event.target.value.replace(/\D/g, '').slice(0, 6)

  let formatted = ''
  for (let i = 0; i < raw.length; i++) {
    formatted += raw[i]
    if (i === 1 || i === 3) {
      formatted += '-'
    }
  }

  // Remove trailing dash if input is incomplete
  formatted = formatted.replace(/-$/, '')

  emit('update:sortCode', formatted)
}

</script>